"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserConferencerVoipCallerComponentParameters = void 0;
exports.UserConferencerVoipCallerComponentParameters = [
    {
        id: 'minRecordingLength',
        label: 'Min Recording Length',
        description: 'Input Param - Minimum length (in seconds) required for recording.',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'maxRecordingLength',
        label: 'Max Recording Length',
        description: 'Input Param - Maximum length (in seconds) allowed for recording.',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'topicOfDiscussion',
        label: 'Topic of Discussion',
        description: 'Input Param - Topic or agenda for the call.',
        type: 'string',
        paramType: 'STRING',
        required: false,
    },
    {
        id: 'callType',
        label: 'Call Type',
        description: 'Input Param - The type of call to be placed.',
        type: 'fixed',
        paramType: 'ENUM',
        value: 'VOIP',
        required: false,
    },
    {
        id: 'provider',
        label: 'Provider',
        description: 'Input Param - The VoIP provider to use.',
        type: 'fixed',
        paramType: 'ENUM',
        value: 'DAILYCO',
        required: false,
    },
    {
        id: 'calleeNumber',
        label: 'Callee Number',
        description: 'Output Param - The resolved or validated callee phone number.',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'duration',
        label: 'Call Duration',
        description: 'Output Param - The duration of the call in seconds.',
        type: 'output',
        paramType: 'INT',
        required: true,
    },
    {
        id: 'meetingLink',
        label: 'Meeting Link',
        description: 'Output Param - The meeting link for the VoIP call.',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'conferenceId',
        label: 'Conference ID',
        description: 'Output Param - The conference ID for the VoIP call.',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
];
//# sourceMappingURL=UserConferencerVoipCallerComponent.js.map